import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { api, loadStoredMember, storeMember } from "@/lib/api";

export default function MembershipSuccess() {
  const [params] = useSearchParams();
  const subscriptionId = params.get("subscription_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!subscriptionId) {
      setState("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const res = await api.get(`/payments/paypal/status/${subscriptionId}`);
        if (res.data.payment_status === "paid") {
          setState("premium");
          const stored = loadStoredMember();
          if (stored) {
            const updated = { ...stored, tier: "premium" };
            storeMember(updated);
          }
          return;
        }
      } catch {}
      attempts += 1;
      if (attempts < 12) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [subscriptionId]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-6" data-testid="membership-success-page">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-lg text-center"
      >
        <img src="/assets/logo.png" alt="" className="mx-auto h-24 w-24 rounded-full object-cover" />
        {state === "premium" ? (
          <>
            <h1 className="mt-8 font-serif text-4xl tracking-tight md:text-5xl" data-testid="success-heading">
              Welcome to <em className="text-wine">Premium.</em>
            </h1>
            <p className="mt-6 text-sm leading-relaxed text-ink/65 md:text-base">
              Your subscription is active. Priority bottles, free shipping and the
              reserve cellar are yours from the very next drop.
            </p>
          </>
        ) : state === "checking" ? (
          <>
            <h1 className="mt-8 font-serif text-4xl tracking-tight" data-testid="success-heading">Corking it in…</h1>
            <p className="mt-6 text-sm text-ink/65">Confirming your subscription with PayPal.</p>
          </>
        ) : (
          <>
            <h1 className="mt-8 font-serif text-4xl tracking-tight" data-testid="success-heading">Almost there</h1>
            <p className="mt-6 text-sm leading-relaxed text-ink/65">
              PayPal is still confirming your subscription — this can take a minute.
              Your membership page will update itself.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="success-home-link"
          className="mt-10 inline-block rounded-full bg-wine px-8 py-4 text-sm uppercase tracking-widest text-paper transition-colors duration-300 hover:bg-ink"
        >
          Back to the club
        </Link>
      </motion.div>
    </main>
  );
}
